import createWidgetLoader from 'components-framework/widget/create_widget_loader';
import membershipRenewalReactivationManagerFactory from 'components/membership/membership_renewal_reactivation_manager/js/main';

const pageSetup = (pageName) => {
    $('#page').removeClass().addClass(`${pageName}`);
    Odigeo.Session.set('page', pageName);
    Odigeo._.extend(Odigeo.Model.prototype, {
        error500() {},
    });
};

Odigeo.Router.handlers.membership_renewal_reactivation = function() {
    const pageName = 'membership_renewal_reactivation';

    const widgetLoader = createWidgetLoader({
        membershipRenewalReactivationManager: ['membership-renewal-reactivation-manager', membershipRenewalReactivationManagerFactory],
    });

    pageSetup(pageName);

    // Initialize
    Odigeo.Router.eventController.execute();
    Odigeo.Utils.sessionTimer.reset();

    widgetLoader.get('membershipRenewalReactivationManager');
};
